import dayjs from 'dayjs';
import { selectorFamily } from 'recoil';
import * as vodaLend from '../api/vodaLend';

const fetchStateAdvanceRepayment = async (applicationId) => await vodaLend.getAdvanceRepayment(applicationId);
const fetchStateAdvance = async (applicationId) => await vodaLend.getAdvance(applicationId);

export const btaTransactionHistory = selectorFamily({
  key: 'btaTransactionHistory',
  get: (applicationId) => async () => {

    const data = await fetchStateAdvanceRepayment(applicationId) || { records: [], total: {} };

    return {
      records: data.records.map((d) => ({
        displayDate: d.dueDate ? dayjs(d.dueDate).format('DD-MMM-YY') : '',
        capital: d.principalAmount,
        cost: d.costAmount,
        paymentAmount: d.paymentAmount,
        repaymentState: d.repaymentState,
        paidAmount: d.paidAmount,
        arrears: d.arrearsAmount,
        earlySettlement: d.earlySettlement,
        paidDate: d.paidDate ? dayjs(d.paidDate).format('DD-MMM-YY') : ''
      })),
      total: {
        capital: data.total?.principalAmount,
        cost: data.total?.costAmount,
        paymentAmount: data.total?.paymentAmount,
        paidAmount: data.total?.paidAmount,
        arrears: data.total?.arrearsAmount,
        earlySettlement: data.total?.earlySettlement
      }
    };
  }
});

export const btaAccountSummary = selectorFamily({
  key: 'btaAccountSummary',
  get: (applicationId) => async () => {

    const d = await fetchStateAdvance(applicationId);

    if (!d) {
      return d;
    }

    return {
      advanceId: d.advanceId,
      advanceAmount: d.advanceAmount,
      arrearsAmount: d.arrearsAmount,
      remainingCapital: d.remainingCapital,
      remainingBalance: d.remainingBalance,
      // earlySettleAmount: 2012345, // TODO: uncomment this in future when we get the related field from LLL (eugene)
      totalRepaid: d.repaidAmount,
      totalOutstanding: d.remainingBalance,
      totalRepayments: d.totalRepayments
    };
  }
});